import { render, staticRenderFns } from "./MyDownloads.vue?vue&type=template&id=70b09074&scoped=true"
import script from "./MyDownloads.vue?vue&type=script&lang=js"
export * from "./MyDownloads.vue?vue&type=script&lang=js"
import style0 from "./MyDownloads.vue?vue&type=style&index=0&id=70b09074&prod&lang=scss&scoped=true"
import style1 from "./MyDownloads.vue?vue&type=style&index=1&id=70b09074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b09074",
  null
  
)

export default component.exports